import React from "react";
import { Chip } from "./Chip";

export const BoolChip = React.forwardRef((props, ref) => {
    const { filterValue, title, trans } = props,
          value = ({
            true: trans("yes"),
            false: trans("no"),
          })[filterValue?.value],
          label= value ? `${title}: ${value}` : title,
          tooltip = value ? label : "";

    return <Chip ref={ ref } { ...props } tooltip={tooltip} icon="checkbox-intermediate" iconFamily="material-community" title={label} />
})